import { Card, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { ReactElement } from "react";
import MaintenanceHistory from "./components/MaintenanceHistory";
import MaintenanceRequestTile from "./components/MaintenanceRequestTile";

export default function Maintenance(): ReactElement {
  const useStyles = makeStyles({
    maintenanceContainer: {
      background: "#FFFFFF",
      borderRadius: "24px",
      boxShadow: "none !important",
      height: 250,
      padding: 20,
    },
    historyContainer: {
      background: "#FFFFFF",
      borderRadius: "24px",
      boxShadow: "none !important",
      height: "430px",
      padding: 20,
    },
  });

  const classes = useStyles();

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <Grid container>
        <Grid item xs={12}>
          <Card className={classes.maintenanceContainer}>
            <MaintenanceRequestTile />
          </Card>
        </Grid>
        <Grid item xs={12} mt={2}>
          <Card className={classes.historyContainer}>
            <MaintenanceHistory />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
